import React, { useState } from "react";
import { apiAxios as axios } from "../../utils/apiClient.js";
import Compressor from "compressorjs";
import "./ReviewScreenAfterDelivered.css";
import { useAuth } from "../../utils/AuthContext";
import { url } from "../../Constant/TextConstant";

const ReviewScreenForProductAfterDelivered = ({
  providerMobile,
  productCode,
  forService = false, // true for service, false for product
}) => {
  const [selectedRating, setSelectedRating] = useState(null);
  const [hoverRating, setHoverRating] = useState(null);
  const [reviewText, setReviewText] = useState("");
  const [imageFiles, setImageFiles] = useState([null, null]);
  const [loading, setLoading] = useState(false);
  const emojis = ["😡", "😐", "🙂", "😍", "🌟"];
  const labels = ["Terrible", "Meh", "Good", "Great", "Excellent"];

  const {currentUserName, currentUser} = useAuth();
  const pickImage = (idx, file) => {
    new Compressor(file, {
      quality: 0.6,
      maxWidth: 800,
      success(result) {
        const newFiles = [...imageFiles];
        newFiles[idx] = result;
        setImageFiles(newFiles);
      },
    });
  };

  const removeImage = (idx) => {
    const newFiles = [...imageFiles];
    newFiles[idx] = null;
    setImageFiles(newFiles);
  };

  const uploadImage = async (file) => {
    const form = new FormData();
    form.append("file", file, file.name);
    const resp = await axios.post(
      `${url.baseAPIUrl}/api/UploadImage/UploadReviewImage`,
      form
    );
    return resp.data.trim().replace(/"/g, "");
  };

  const submitReview = async () => {
    if (!selectedRating || !reviewText.trim()) {
      return alert("Please select a rating and write a review");
    }

    setLoading(true);

    try {
      // Upload images if they exist
      const uploaded = await Promise.all(
        imageFiles.map((f) => (f ? uploadImage(f) : Promise.resolve("")))
      );

      // Determine which API to use based on forService prop
      const apiUrl = forService
        ? `${url.baseAPIUrl}/api/ServiceLikeReviewCall/SubmitReview`
        : `${url.baseAPIUrl}/api/ShopkeeperLikeReviewAndCall/SubmitReview`;

      const params = forService
        ? {
            rating: selectedRating,
            review: reviewText,
            providermobile: providerMobile,
            customermobile: currentUser,
            name: currentUserName || "Guest",
            image1: uploaded[0] || "",
            image2: uploaded[1] || "",
          }
        : {
            rating: selectedRating,
            review: reviewText,
            StoreMobile: providerMobile,
            customermobile: currentUser,
            name: currentUserName || "Guest",
            ProductCode: productCode,
            image1: uploaded[0] || "",
            image2: uploaded[1] || "",
          };

      await axios.post(apiUrl, null, { params });

     
      alert("Review submitted successfully");

      // Reset form
      setSelectedRating(null);
      setReviewText("");
      setImageFiles([null, null]);

      // Call success callback if provided
    //   if (onSuccess) onSuccess();    
    } catch (e) {
      alert(
        `Failed to submit review: ${e.response?.data?.message || e.message}`
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="review-loading-container">
        <div className="review-loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="review-card">
      <h2 className="review-title">Share Your Experience</h2>

      <div className="emoji-container">
        {emojis.map((emo, idx) => (
          <div key={idx} className="emoji-wrapper">
            <div
              className={`emoji ${
                selectedRating === idx + 1 ? "selected" : ""
              }`}
              onClick={() => setSelectedRating(idx + 1)}
              onMouseEnter={() => setHoverRating(idx + 1)}
              onMouseLeave={() => setHoverRating(null)}
              style={{
                transform:
                  hoverRating === idx + 1
                    ? "scale(1.2)"
                    : selectedRating === idx + 1
                    ? "scale(1.2)"
                    : "scale(1)",
              }}
            >
              {emo}
            </div>
            <div
              className={`emoji-label ${
                selectedRating === idx + 1 ? "active" : ""
              } ${hoverRating === idx + 1 ? "hover" : ""}`}
            >
              {(hoverRating === idx + 1 || selectedRating === idx + 1) &&
                labels[idx]}
            </div>
          </div>
        ))}
      </div>

      <textarea
        className="review-textarea"
        placeholder="Tell us more about your experience..."
        value={reviewText}
        onChange={(e) => setReviewText(e.target.value)}
      />

      <div className="image-section">
        <p className="image-title">Add Photos (Optional)</p>
        <div className="image-grid">
          {imageFiles.map((file, idx) => (
            <div key={idx} className="image-box">
              {file ? (
                <>
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`Review ${idx + 1}`}
                    className="image-preview"
                  />
                  <button
                    className="remove-button"
                    onClick={() => removeImage(idx)}
                  >
                    ✕
                  </button>
                </>
              ) : (
                <label className="add-image-label">
                  +
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      e.target.files && pickImage(idx, e.target.files[0])
                    }
                  />
                </label>
              )}
            </div>
          ))}
        </div>
      </div>

      <button
        className="submit-button"
        onClick={submitReview}
        disabled={!selectedRating || !reviewText.trim()}
      >
        Submit Review
      </button>
    </div>
  );
};

export default ReviewScreenForProductAfterDelivered;
